import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStatePostSingle = {
  postSingle: { data: null, loading: false, error: null },
};

export const postSingle = createAsyncThunk('user/postSingle', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .get(`/post/${data.id}`, {
      params: data,
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerPostSingle = {
  [postSingle.pending]: (state) => {
    state.postSingle.loading = true;
  },
  [postSingle.fulfilled]: (state, action) => {
    state.postSingle.loading = false;
    state.postSingle.data = action.payload;
    state.postSingle.error = null;
  },
  [postSingle.rejected]: (state, action) => {
    state.postSingle.data = null;
    state.postSingle.loading = false;
    state.postSingle.error = action.payload;
  },
};
